import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideTranslateLoader,
  provideTranslateService,
  TranslateLoader,
  TranslationObject,
} from '@ngx-translate/core';
import { WA_POSITION_OPTIONS } from '@ng-web-apis/geolocation';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideNgxMask } from 'ngx-mask';
import { provideLottieOptions } from 'ngx-lottie';
import { environment } from '../environments/environment';
import { CAPTURE_LOCATION_POSITION_OPTIONS } from './shared/services/capture-location.service';

const publicTranslateLoader = (): TranslateLoader => {
  const httpClient = inject(HttpClient);

  return {
    getTranslation: (lang: string) => httpClient.get<TranslationObject>(`assets/i18n/${lang}.json`),
  };
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideNgxMask(),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    {
      provide: WA_POSITION_OPTIONS,
      useValue: CAPTURE_LOCATION_POSITION_OPTIONS,
    },
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideTranslateService({
      loader: provideTranslateLoader(publicTranslateLoader),
      lang: environment.lenguage || 'es',
      fallbackLang: environment.lenguage || 'es',
    }),
  ],
};
